import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { compose } from 'recompose'
import { clearLessonDetail } from '../../common/lessons/actions'
import { ExerciseTestForm } from '../components'

/* TODO pure component */
class FirstListPage extends React.Component {
  componentDidMount() {
    this.props.clearLessonDetail()
  }

  render() {
    const { intl, history } = this.props

    return (
      <div className="overlay-container">
        <ExerciseTestForm
          hide={() => { history.push('/onboarding') }}
          subscribeRedirect={() => { history.push('/onboarding-learn') }}
        />
      </div>
    )
  }
}


FirstListPage.propTypes = {
  history: PropTypes.object.isRequired,
}

const enhance = compose(
  connect((state) => ({ }),
  { clearLessonDetail }),
  injectIntl,
)

export default enhance(FirstListPage)

/*
const messages = defineMessages({
  class: {
    id: 'groupDetail.page.class',
    defaultMessage: 'Trieda',
  },
  students: {
    id: 'groupDetail.page.students',
    defaultMessage: 'Študenti',
  },
  lastTest: {
    id: 'groupDetail.page.lastTest',
    defaultMessage: 'Posledný test',
  },
  noStudents: {
    id: 'groupDetail.page.noStudents',
    defaultMessage: 'Zatiaľ nie su pridaný v tejto triede žiadny študenti.',
  },
})
*/



// WEBPACK FOOTER //
// ./src/browser/pages/FirstListPage.js